import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

import 'react-slideshow-image/dist/styles.css';

import 'simplebar-react/dist/simplebar.min.css';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
